import { CommonModule } from '@angular/common';
import { NgModule, Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'eui-common-header',
    templateUrl: './common-header.component.html',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiCommonHeaderComponent {

    @HostBinding('class')
    get cssClasses() {
        return [
            `eui-common-header`,
            this.isCollapsed ? 'eui-common-header--collapsed' : '',
        ].join(' ').trim();
    }

    @Input() label;
    @Input() subLabel;

    @Input() isHighlighted = false;
    @Input() isCollapsed = false;

    constructor(
    ) {}
}

/* ***************************************** */
/* MODULE EXPORT */
/* ***************************************** */
@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiCommonHeaderComponent,
    ],
    exports: [
        EuiCommonHeaderComponent,
    ],
})
export class EuiCommonHeaderModule { }
